<div
  *ngIf="parentFormGroup.controls[controlName]"
  class="font-work-sans font-regular {{screenType}}"
>
  <div
    class="form-field-label {{type}}"
    *ngIf="label"
  >
    {{label}}
    <span
      *ngIf="isRequired"
      class="required-mark"
    >*</span>
  </div>
  <mat-form-field
    [formGroup]="parentFormGroup"
    appearance="outline"
    class="form-field w-full"
    [ngClass]="type?'small' : ''"
    hideRequiredMarker
  >
    <mat-icon
      *ngIf="suffixIcon"
      class="suffix"
      matSuffix
      svgIcon="{{suffixIcon}}"
      (click)="suffixClick()"
    ></mat-icon>
    <input
      #input
      class="input {{type}} number-input"
      [formControlName]="controlName"
      [max]="max"
      [maxlength]="maxLength"
      [min]="min"
      matInput
      placeholder="{{placeholder}}"
      type="text"
      phoneNumber
    >
    <mat-icon
      class="prefix"
      matPrefix
      svgIcon="country-code"
    ></mat-icon>

    <mat-error *ngIf="error">{{error}}</mat-error>
  </mat-form-field>
</div>
